import { Form, Route, Routes } from "react-router-dom";
import { Box, ChakraProvider, Portal, Flex } from "@chakra-ui/react";
import PublicPage from "../../pages/public/landingPage";
import theme from "theme/theme";
import Footer from "common/components/Footer/Footer";
import Header from "common/components/Header/Header";
import Landing from "pages/public/components/landing/Landing";
import LandingForm from "pages/public/components/landing/Form";
function Public() {
  return (
    <ChakraProvider
      theme={theme}
      //resetCSS={false}
    >
      <div className="landing-component">
        <div>
          <Header headerClass="header-Landing" textClass="logoText-landing" />
        </div>
        <PublicPage />
        {/* <Routes>
            <Route path="/form" element={<LandingForm />} />
            <Route path="/" element={<Landing />} />
          </Routes> */}
        <Footer />
      </div>
    </ChakraProvider>
  );
}

export default Public;
